import { asArrayFirst } from '../object/asArray.js';
function isNumberLike(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        value instanceof String ||
        value instanceof Number);
}
function isEntryWise(value) {
    if (typeof value !== 'object' || value === null) {
        return false;
    }
    return (Symbol.iterator in value ||
        typeof value.length === 'number');
}
function finiteOrDefault(value, defaultValue) {
    if (!isNumberLike(value) || String(value).trim() === '') {
        return defaultValue;
    }
    const converted = Number(value);
    return Number.isFinite(converted) ? converted : defaultValue;
}
export function toFiniteNumber(value, defaultValue) {
    if (isNumberLike(value) || !isEntryWise(value)) {
        return finiteOrDefault(value, defaultValue);
    }
    return Array.from(value, (entry) => finiteOrDefault(entry, defaultValue));
}
export function toFiniteFirst(value, defaultValue) {
    return finiteOrDefault(asArrayFirst(value), defaultValue);
}
export function toFiniteVector(value, length) {
    if (isNumberLike(value) || !isEntryWise(value)) {
        return undefined;
    }
    const numbers = Array.from(value, (entry) => finiteOrDefault(entry));
    return numbers.length === length && numbers.every((n) => n !== undefined)
        ? numbers
        : undefined;
}
export function toNumber(val) {
    if (val === undefined || val === null) {
        return undefined;
    }
    if (isNumberLike(val)) {
        return Number(val);
    }
    if (Array.isArray(val)) {
        return val.map((entry) => Number(entry));
    }
    if (typeof val === 'object' && Symbol.iterator in val) {
        return Array.from(val, (entry) => Number(entry));
    }
    return Number(val);
}
export default toNumber;
